<template>
  <v-row class="ma-0">
    <v-col cols="12" sm="6" md="6">
      <div class="text-right">
        <small
          class="blue--text pointer"
          @click="clearCampaign"
        >
          All campaigns
        </small>
        <v-select
          :items="campaigns"
          :value="selectedCampaign"
          item-text="name"
          item-value="id"
          label="Select campaign"
          single-line
          class="select-bordered"
          @change="setCampaign"
        />
      </div>
    </v-col>
    <v-spacer />
    <v-col cols="12" sm="6" md="6">
      <div class="text-right">
        <small
          class="blue--text pointer"
          @click="clearIssue"
        >
          All ad groups
        </small>
        <v-select
          :disabled="!issues.length"
          :value="selectedIssue"
          :items="issues"
          item-text="name"
          item-value="id"
          label="Select ad group"
          single-line
          class="select-bordered"
          @change="setIssue"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'message-report-item-selector',
    props: {
      campaigns: {
        type: Array,
        default: () => []
      },
      selectedCampaign: {
        type: String,
        default: null
      },
      selectedIssue: {
        type: String,
        default: null
      }
    },
    computed: {
      issues () {
        if (!this.selectedCampaign) return []
        return this.campaigns.find(c => c.id === this.selectedCampaign).issues
      }
    },
    methods: {
      setCampaign (id) {
        this.$emit('setCampaignId', id)
      },
      setIssue (id) {
        this.$emit('setIssueId', id)
      },
      clearCampaign () {
        this.$emit('setCampaignId', null)
      },
      clearIssue () {
        this.$emit('setIssueId', null)
      }
    }
  }
</script>
